import { observer } from '@formily/react';
import { IAnyObject } from '@yimoka/shared';
import { BaseStore, getEntityStore, IEntityConfig } from '@yimoka/store';
import React, { useEffect } from 'react';

import { useDeepMemo } from '../../hooks/deep-memo';
import { useEntityConfig } from '../../hooks/entity-config';

import { Entity, IEntityProps } from './base';

export const EntityList = observer((props: IEntityListProps) => {
  const { config, store, scope, entity, instanceKey, dispose, ...args } = props;
  const curConfig = useEntityConfig(config ?? entity?.config);

  const curStore = useDeepMemo(() => {
    if (store instanceof BaseStore) {
      return store;
    }
    if (entity) {
      return entity.getList({ ...(store ?? {}), instanceKey });
    }
    return getEntityStore(store, 'list', curConfig);
  }, [store, entity, instanceKey, curConfig]);

  useEffect(() => {
    if (!dispose || !entity || store instanceof BaseStore) return;
    return () => {
      entity.disposeList(instanceKey);
    };
  }, [dispose, entity, store, instanceKey]);

  const useScope = useDeepMemo(() => ({ $entity: entity, $config: curConfig, ...scope }), [entity, curConfig, scope]);

  return <Entity {...args} scope={useScope} store={curStore} />;
});

export type IEntityListProps<V extends object = IAnyObject, R extends object = IAnyObject> = Partial<IEntityProps<V, R>> & {
  /** false 表示不继承 scope 中的 $config，与 useEntityConfig 对齐 */
  config?: IEntityConfig<V> | false;
}
